import { render } from "./LdapSyncConnection.vue?vue&type=template&id=ae2b7cba&scoped=true"
import script from "./LdapSyncConnection.vue?vue&type=script&lang=js"
export * from "./LdapSyncConnection.vue?vue&type=script&lang=js"

import "./ldap-sync-connection.scss?vue&type=style&index=0&id=ae2b7cba&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae2b7cba"]])

export default __exports__